import { render } from "./NostoCarouselHelper.vue?vue&type=template&id=84fb2c28"
import script from "./NostoCarouselHelper.vue?vue&type=script&lang=js"
export * from "./NostoCarouselHelper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__